<template>
  <div class="orderDeatiStyle">
    <top-component></top-component>
    <div class="orderContent">
      <el-table :data="tableData" style="width: 100%;margin-top: 30px;">
        <el-table-column prop="createTime" label="日期">
        </el-table-column>
        <el-table-column prop="goodsName" label="商品名称">
        </el-table-column>
        <el-table-column prop="goodsSign" label="商品编号">
        </el-table-column>
        <el-table-column prop="price" label="采购价">
        </el-table-column>
        <el-table-column prop="amount" label="数量">
        </el-table-column>
        <el-table-column prop="totalPrice" label="小计">
        </el-table-column>
        <el-table-column fixed="right" label="操作"  align="center">
            <template slot-scope="scope">
              <el-button type="primary" icon="el-icon-edit" size="mini" @click="propsedit()">打印</el-button>
            </template>
          </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="pages.currentPage" :page-size="pages.pagesize" layout="prev, pager, next, jumper"
        :total="pages.total">
      </el-pagination>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import TopComponent from '../Components/TopComponent.vue'
  import BottomComponent from '../Components/BottomComponent.vue'
  import { byId } from '@/api/pages'
  export default {
    name: 'HelloWorld',
    data() {
      return {
        tableData: [],
        pages: {
          currentPage: 1,
          pagesize: 10,
          total: 100
        },
      }
    },
    mounted() {
    //   console.log(this.$route.params.orderId)
      this.ApiData()
    },
    methods: {
      propsedit(){
        window.print();
      },
      // 中图分类
      async ApiData() {
        let data =  {
          pageNum: this.pages.currentPage,
          pageSize: this.pages.pagesize,
          ids: this.$route.query.orderId
        }
        let res = await byId(data)
        if(res.code == '200'){
          this.tableData = res.data.list
          this.pages.total = res.data.total
        }
      },
      // 分页
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`)
        this.pages.currentPage = val
        this.ApiData()
      }
    },
    components: { TopComponent, BottomComponent }
  }
</script>

<style scoped lang="scss">
  .orderDeatiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  .orderContent {
    width: 1200px;
    margin-left: calc(50% - 600px);
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Order-Detail.vue